module.exports = __webpack_public_path__ + "img/product_2.afccd5ef.png";